import { render, staticRenderFns } from "./Mutterkuh-SCard.vue?vue&type=template&id=3a2234ac&scoped=true&"
import script from "./Mutterkuh-SCard.vue?vue&type=script&lang=js&"
export * from "./Mutterkuh-SCard.vue?vue&type=script&lang=js&"
import style0 from "./Mutterkuh-SCard.vue?vue&type=style&index=0&id=3a2234ac&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2234ac",
  null
  
)

export default component.exports